import axiosInstance from "./axiosInstance";
import { webAuth } from "../apis/webAuthLogin";

export const postLead = async (leadData) => {
  try {
    console.log('Sending lead data:', leadData);
    const response = await fetch('https://infrec.in/php-backend/backend/lead/save-lead.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(leadData)
    });

    console.log('Response status:', response.status);
    const text = await response.text();
    console.log('Response text:', text);
    
    if (!text) {
      return { success: false, message: "Empty response from server" };
    }
    
    const data = JSON.parse(text);
    console.log('Response data:', data);
    return data;
  } catch (error) {
    console.error('Error in postLead:', error);
    return { success: false, message: "Something went wrong" };
  }
};

